// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/styles/reset.css'
import $global from './assets/javascript/global' // 全局事件
import $routes from './assets/javascript/routes' // 路由事件
// 引入自定义字体
import "./assets/fonts/fonts.css"
import VantGreen from 'vant-green';
import 'vant-green/lib/index.css';
// api详细
import api from "./api/index";
Vue.prototype.$api = api;
// 引入ElementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  VantGreen,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js